import React, { useState } from 'react';
import { Flex, Modal } from 'antd-mobile';
import styles from './index.module.less';

const BottomSheetModal = ({ visible, onClose, list, onSelect }) => {
  const [currentType, setCurrentType] = useState(null);

  const handleItemClick = (item) => {
    setCurrentType(item.type);
    onSelect(item);
    onClose();
  };

  return (
    <Modal
      wrapClassName={styles.modalContainer}
      visible={visible}
      transparent
      maskClosable
      onClose={onClose}>
      <Flex className={styles.modal_center} direction="column">
        {(list || []).map((item, index) => {
          return (
            <Flex
              className={styles.flex_item}
              style={{ color: currentType === item.type ? '#F01B3F' : '#333333' }}
              key={`flex_item_${index}`}
              align="center"
              justify="center"
              onClick={() => handleItemClick(item)}>
              {item.name}
            </Flex>
          );
        })}
      </Flex>
      <Flex className={styles.modal_footer} justify="center" align="center" onClick={onClose}>
        <span>取消</span>
      </Flex>
    </Modal>
  );
};

export default BottomSheetModal;



// WEBPACK FOOTER //
// ./src/pubBiz/BottomSheet/index.js